module.exports = __webpack_public_path__ + "static/media/giggling_squid.3ae34241.jpg";